module.exports = __webpack_public_path__ + "static/media/tasks-alt.606859ad.svg";